import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

interface LoginButtonProps {
  label?: string;
  className?: string;
}

/**
 * Login button that initiates Google OAuth flow
 */
const LoginButton: React.FC<LoginButtonProps> = ({ 
  label = 'Login with Google',
  className = 'btn btn-primary'
}) => {
  const { login } = useAuth();

  return (
    <button 
      onClick={login} 
      className={className}
      type="button"
      aria-label="Login with Google"
    >
      {label}
    </button>
  );
};

export default LoginButton; 